import { PageId } from 'constants/pages'

export const enum PageIdWoofzVday80 {
  SUBSCRIPTIONS_VDAY_80 = PageId.SUBSCRIPTIONS_VDAY_80,
  CHAT_UPSELL_VDAY_80 = PageId.CHAT_UPSELL_VDAY_80,
  UPSELL_VDAY_80 = PageId.UPSELL_VDAY_80,
  DOWNLOAD_VDAY_80 = PageId.DOWNLOAD_VDAY_80,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
